<template>
  <div class="mt-15">
    <div class="tixstock-event-card-heading"></div>
    <div class="tixstock-cards-grid">
      <div
        v-for="index in 12"
        :key="index"
        class="tixstock-card-skeleton"
      >
        <div class="card-image-skeleton"></div>
        <div class="card-content-skeleton">
          <div class="card-date-skeleton"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonTixstockTrendingCategories'
}
</script>


<style scoped>
.tixstock-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* ✅ 4 cards per row */
  gap: 20px;
  width: 100%;
}

.tixstock-card-skeleton {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.card-image-skeleton {
  height: 160px;
  background: #e0e0e0;
  animation: pulse 1.5s infinite;
}

.card-content-skeleton {
  padding: 14px;
}

.card-date-skeleton {
  height: 16px;
  width: 120px;
  background: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

.tixstock-event-card-heading {
  height: 22px;
  width: 220px;
  background: #e0e0e0;
  border-radius: 4px;
  margin: 0 0 16px 8px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-color: #f0f0f0;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #f0f0f0;
  }
}

@media (max-width: 992px) {
  .tixstock-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .tixstock-cards-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .card-image-skeleton {
    height: 140px;
  }
}

</style>